import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IReportAgendamentoFilterParams,
  IReportServicosEntradaFilterParams
} from './report.model';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient) {}

  public GetAgendamentoFilter(
    params?: IReportAgendamentoFilterParams
  ): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportAgendamentosFilter`;
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ''
        ) {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<any>(url, { params: httpParams });
  }

  public GetPreco(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportPrecos`;

    return this.http.get<any>(url);
  }

  public GetEmpresa(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportEmpresas`;

    return this.http.get<any>(url);
  }

  public GetEntradaGate(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportGateEntradas`;

    return this.http.get<any>(url);
  }

  public GetOrdemServico(
    FK_EPSA: number,
    DT_SRVC_ENTR_INIC?: string,
    DT_SRVC_ENTR_FIM?: string
  ): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportOrdemServico`;

    let params: any = {};
    if (FK_EPSA) {
      params.FK_EPSA = FK_EPSA;
    }
    if (DT_SRVC_ENTR_INIC && String(DT_SRVC_ENTR_INIC).trim() !== '') {
      params.DT_SRVC_ENTR_INIC = DT_SRVC_ENTR_INIC;
    }
    if (DT_SRVC_ENTR_FIM && String(DT_SRVC_ENTR_FIM).trim() !== '') {
      params.DT_SRVC_ENTR_FIM = DT_SRVC_ENTR_FIM;
    }

    return this.http.get<any>(url, { params });
  }

  public GetReportServicosEntradas(
    params?: IReportServicosEntradaFilterParams
  ): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportServicosEntradas`;
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ''
        ) {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<any>(url, { params: httpParams });
  }
}
